import React, { Component }            from 'react';
import { ClipLoader }                  from 'react-spinners';
import { FaForward }                   from 'react-icons/fa';
import { MdError }                     from 'react-icons/md';
import { MdCheckCircle }               from 'react-icons/md';
import { withRouter }                  from 'react-router';
import { connect }                     from 'react-redux';
import { EmployeeOnboardingConstants } from '../../environment';
import { reminderFetchData }           from '../../../../../actions/employee-onboarding/reminder';

var apiHost = EmployeeOnboardingConstants.WebApiHost;

class Reminder extends Component {
    
  constructor(props) {
    super(props);
    this.state = {
      group : this.props.group,
      item  : this.props.item
    };

    this.reminder    = this.reminder.bind(this);
    this.params      = this.params.bind(this);
  }

  params() {
    var newEmployee = this.state.item.NewEmployeeId 
                      ? this.state.item.NewEmployeeId
                      : this.state.group.Employee;
    
    var params = {
      requestor       : this.state.item.RequestorId,
      new_employee    : newEmployee,
      make_like       : this.state.item.MakeLikeId,
      sr              : this.state.item.SR,
      DoorRequest     : this.state.item.DoorRequest,
      GroupRequest    : this.state.item.GroupRequest,
      group_overrides : [{
        name       : this.state.group.Group,
        approve_id : this.state.group.ApproveId,
        deny_id    : this.state.group.DenyId
      }]
    };

    return params;
  }

  reminder() {
    var params = this.params();
    this.props.fetchData(apiHost, params);  
  }
  
  render() { 
    let status = null;
    if (this.props.reminderHasErrored && 
        this.props.reminder.sr !== this.state.item.SR &&
        this.state.group.ApproveId === this.props.reminder.group_overrides[0].approve_id) {
      status = 
        <span title='Error sending the notication'>
          <MdError size={24} color='red' />
        </span>;
    }    

    if (this.props.reminder.sr === this.state.item.SR && 
        !this.props.reminderHasErrored &&
        this.state.group.ApproveId === this.props.reminder.group_overrides[0].approve_id) {
      status = 
        <span title='Notification sent successfully'>
          <MdCheckCircle size={24} color='green' />
        </span>;
    }

    let html = null;
    if (this.props.reminderIsLoading) {
      html = 
        <ClipLoader
          color={'#072659'}
          loading={this.props.reminderIsLoading}
        />;
    }
    else {
      html = 
        <div>
          { !this.state.group.Completed ?
            <div>
              <b style={{ marginRight: '5px' }}>Re-send Notification</b>
              <button onClick={this.reminder}> <FaForward size={24} /></button>
              {status}
            </div>
            :
            <span />
          }
        </div>;
    }

    return (   
      <div>
        {html}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    reminder: state.employee.reminder.reminder,
    reminderHasErrored: state.employee.reminder.reminderHasErrored,
    reminderIsLoading: state.employee.reminder.reminderIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchData: (host, params) => dispatch(reminderFetchData(host, params))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Reminder));
